(function () {
  'use strict';

  angular.module('ringbaPortal').component('offerSummary', {
    bindings: {
      campaign: '<',
      hideOfferSummary: '&',
      confirmJoinOffer: '&',
      confirmHideOffer: '&',
      participateActionButtonLabel: '<'
    },
    controller: OfferSummaryController,
    controllerAs: 'vm',
    templateUrl: '/scripts/shared/components/offer-summary/offer-summary.view.html'
  });

  function OfferSummaryController(
    accountsService,
    offersService
  ) {
    'ngInject';

    const vm = this;

    vm.showPayoutSection = true;

    vm.$onInit = onInit;
    vm.togglePayoutsSection = togglePayoutsSection;

    function onInit() {
      _loadOfferSummartData(vm.campaign.id);
    }

    function togglePayoutsSection(show) {
      vm.showPayoutSection = show;
    }

    function _loadOfferSummartData(campaignId) {
      offersService.getCampaignOfferDetails(accountsService.currentAccountId, campaignId).then(function(response) {
        vm.currentOffer = response.data.offer;
        vm.currentOffer.rtbState = response.data['rtb'].setup ? response.data['rtb'].enabled : false;
      });
    }

  }
})();
